/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Scheduled/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaIconEvent from 'DesignSystem/Svgs/TysiaIconEvent/index'



/** @type {import('Simple/types.js').View} */
export default function Scheduled({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Indicator/Past/Icon/Scheduled"
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<TysiaIconEvent
  viewPath={`${viewPath}/TysiaIconEvent`}
 fill={dtColorsWhite}
 width={16}
 height={16}
/>
{children}
</React.Fragment>)
}